export default "__VITE_ASSET__vEdwoGdw__"